import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "./App.css";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import PublicMenu from "./pages/PublicMenu";
import PublicMenuIndex from "./pages/PublicMenuIndex";
import api from "./lib/api";

function RootRedirect() {
  const [destination, setDestination] = useState(null);
  useEffect(() => {
    api.auth.me().then(() => setDestination("/admin")).catch(() => setDestination("/login"));
  }, []);
  return destination ? <Navigate to={destination} replace /> : <div data-testid="root-session-check" />;
}

export default function App() {
  useEffect(() => {
    document.body.style.background = "#FDFBF7";
    document.body.style.color = "#2A2A2A";
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/restaurant" element={<Navigate to="/admin" replace />} />
        <Route path="/menu" element={<PublicMenuIndex />} />
        <Route path="/menu/:slug" element={<PublicMenu />} />
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}